<template>
  <section v-if="show" class="related">
    <div class="head">
      <h3>相关讨论</h3>
      <router-link v-if="composeTo" class="link" :to="composeTo">去论坛发言</router-link>
    </div>
    <p v-if="loading" class="muted">加载讨论…</p>
    <p v-else-if="!threads.length" class="muted">
      暂无相关帖子。
      <router-link v-if="composeTo" :to="composeTo">发起讨论</router-link>
    </p>
    <ul v-else class="list">
      <li v-for="item in threads" :key="item.id">
        <router-link :to="{ path: '/forum', query: { thread: String(item.id) } }">
          {{ item.title }}
        </router-link>
        <span class="meta">
          <template v-if="item.card_name">卡 · {{ item.card_name }} · </template>
          <template v-if="item.bid_label">招标 · {{ item.bid_label }} · </template>
          {{ item.reply_count || 0 }} 回复 · {{ formatTime(item.created_at) }}
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
import { relatedForumThreads } from '../api/platformService'

export default {
  name: 'RelatedDiscussions',
  props: {
    cardId: { type: [Number, String], default: null },
    cardIds: { type: Array, default: () => [] },
    cards: { type: Array, default: () => [] },
    bidJobId: { type: [Number, String], default: null },
    bidLabel: { type: String, default: '' },
    keyword: { type: String, default: '' },
    active: { type: Boolean, default: true }
  },
  data() {
    return {
      threads: [],
      loading: false,
      fetched: false
    }
  },
  computed: {
    show() {
      return this.active && (this.cardId || this.bidJobId || this.keyword || (this.cardIds && this.cardIds.length))
    },
    composeTo() {
      const query = { compose: '1' }
      const first = (this.cards && this.cards[0]) || null
      const cardId = this.cardId || (first && first.id) || (this.cardIds && this.cardIds[0]) || ''
      const cardName = (first && first.name) || ''
      if (cardId) {
        query.card_id = String(cardId)
        if (cardName) query.card_name = cardName
      }
      if (this.bidJobId) {
        query.bid_job_id = String(this.bidJobId)
        if (this.bidLabel) query.bid_label = this.bidLabel
      }
      if (this.keyword) query.title = this.keyword
      else if (cardName) query.title = cardName
      else if (this.bidLabel) query.title = `${this.bidLabel} 讨论`
      return { path: '/forum', query }
    }
  },
  watch: {
    cardId: 'reload',
    bidJobId: 'reload',
    keyword: 'reload',
    cardIds: {
      deep: true,
      handler: 'reload'
    },
    active(v) {
      if (v) this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    formatTime(iso) {
      if (!iso) return ''
      return String(iso).replace('T', ' ').slice(0, 16)
    },
    async reload() {
      if (!this.show) {
        this.threads = []
        return
      }
      this.loading = true
      try {
        const params = { limit: 8 }
        if (this.cardId) params.card_id = this.cardId
        if (this.bidJobId) params.bid_job_id = this.bidJobId
        if (this.keyword) params.q = this.keyword
        if (this.cardIds && this.cardIds.length) params.card_ids = this.cardIds.join(',')
        const data = await relatedForumThreads(params)
        this.threads = data.threads || []
        this.fetched = true
      } catch (e) {
        this.threads = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.related {
  margin-top: 20px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
}
.head h3 { margin: 0; font-size: 16px; }
.link, a { color: #165dff; text-decoration: none; }
.link:hover, a:hover { text-decoration: underline; }
.muted { color: #86909c; font-size: 13px; margin: 0; }
.list { list-style: none; margin: 0; padding: 0; }
.list li {
  padding: 8px 0;
  border-top: 1px solid #f2f3f5;
  display: grid;
  gap: 2px;
}
.list li:first-child { border-top: 0; }
.meta { color: #86909c; font-size: 12px; }
</style>
